import React, {useEffect, useState} from 'react';
import apiClient from "../../http-common";
import { useQuery } from "react-query";

export const Histories = () => {
    const refresh = () => window.location.reload();

    let theme = localStorage.getItem('Klever Elevation-Theme');
    const [currentTheme, setCurrentTheme] = useState(theme);

    const { isLoading: isLoadingHistories, refetch: getHistories } = useQuery(
        "account-histories",
        async () => {
          return await apiClient.get("/api/histories");
        },
        {
          enabled: true,
          onSuccess: (res) => {
            if (res.data.status === 'success') {
    
                let accountHistories = {
                    'withdrawals': res.data.withdrawals,
                    'investments' : res.data.investments,
                    'fundings' : res.data.fundings,
                    'referrals' : res.data.referrals,
                    'plans' : res.data.plans,
                    'wallets' : res.data.wallets,
                    'toasts': res.data.toasts,
                    'investmentHistory': res.data.investmentHistory,
                    'cryptowallets' : res.data.cryptowallets
                }
                localStorage.setItem('binaryfair-account-histories', JSON.stringify(accountHistories));
                const event = new Event('updatedStorage');
                window.dispatchEvent(event);
                const toastEvent = new Event('toastEvent');
                window.dispatchEvent(toastEvent);
            }
          },
          onError: (err) => {
            // console.log(err.response?.data || err);
          },
        }
      );
      useEffect(() => {
        if (document.readyState === "complete") {
            let language = document.getElementsByClassName('goog-te-combo');
           if(language.length > 0){
                language[0].classList.add("bg-theme");
                language[0].classList.add("color-theme");
            }
        }
        
        getHistories();
        window.addEventListener('themeChanged', function (e) {
            let theme = localStorage.getItem('Klever Elevation-Theme');
            if (theme !== null) {
                if (theme === 'dark-mode') {
                   setCurrentTheme('dark-mode')
                }else{
                   setCurrentTheme('light-mode') 
                }
               
            }             
       }, false);
      }, [isLoadingHistories]);

      return (
          <div>
                {currentTheme === "dark-mode"
                ?
                    <div className="icon bg-theme color-theme rounded-circle ">
                        {isLoadingHistories ?
                        
                        <img style={{marginTop: "0px", height: "60px", width: "auto"}} src='https://res.cloudinary.com/djxs33vuk/image/upload/v1779793917/FBF4A039-0B7C-4250-8C82-075C1ED4CEDB_aphjf7.png' alt="loading" />
                        :
                        <img style={{marginTop: "0px", height: "60px", width: "auto"}} onClick={refresh} src='https://res.cloudinary.com/djxs33vuk/image/upload/v1779793917/FBF4A039-0B7C-4250-8C82-075C1ED4CEDB_aphjf7.png' alt="refresh" />
                        }
                    </div>
                :
                    <div className="icon bg-theme color-theme rounded-circle ">
                        {isLoadingHistories ?
                        <img style={{marginTop: "0px", height: "60px", width: "auto"}} src='https://res.cloudinary.com/djxs33vuk/image/upload/v1779793917/FBF4A039-0B7C-4250-8C82-075C1ED4CEDB_aphjf7.png' alt="loading" />
                        :
                        <img style={{marginTop: "0px", height: "60px", width: "auto"}} onClick={refresh} src='https://res.cloudinary.com/djxs33vuk/image/upload/v1779793917/FBF4A039-0B7C-4250-8C82-075C1ED4CEDB_aphjf7.png' alt="refresh" />
                        }
                    </div>
                }
          </div>
            
      )
}

export const referralsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.referrals;
    }
    return accountHistory;

}

export const plansHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.plans;
    }
    return accountHistory;

}

export const walletsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.wallets;
    }
    return accountHistory;

}

export const investmentsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.investments;
    }
    return accountHistory;
}

export const fundingsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.fundings;
    }
    return accountHistory;
}


export const investmentChartHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.investmentHistory;
    }
    return accountHistory;
}

export const withdrawalsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.withdrawals;
    }
    return accountHistory;
}


export const toastsHistory = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.toasts;
    }
    return accountHistory;
}




export const dappWallets = () => {
    let accountHistory = [];
    let storedHistory = localStorage.getItem('binaryfair-account-histories');
    if (storedHistory !== null) {
        let data = JSON.parse(storedHistory);
        accountHistory = data.cryptowallets;
    }
    return accountHistory;
}


